module.exports = __webpack_public_path__ + "static/media/netscape.c4688989.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/netscape.svg
// module id = 995
// module chunks = 0